import styled, { css } from 'styled-components'

import { Cover, Reset, TransitionPrimary } from '@/lib/mixins'

export const PaymentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const PaymentTotal = styled.div`
  margin-bottom: 0.5rem;
  text-align: center;
  flex-shrink: 0;

  h3 {
    font-size: 1rem;
    margin-bottom: 0;
  }
  h2 {
    font-size: 2.2rem;
    color: var(--color-primary);
    margin-bottom: 0;
    line-height: 1;
  }
`

export const PaymentFooter = styled.div`
  width: 75%;
  text-align: center;
  margin: 0 auto;
  padding-top: 0.75rem;
  flex-shrink: 0;
  
  button {
    padding: 0.75rem 1.5rem;
    margin-bottom: 0.5rem;
  }
`

export const PaymentOptions = styled.div`
  background-color: var(--color-light);
  border: 2px solid var(--color-light);
  border-radius: 1rem;
  padding: 0.25rem;
  flex-shrink: 0;

  > h2 {
    text-align: center;
    margin: 0.5rem 0 0.75rem;
    font-size: 1.2rem;
  }
`

export const PaymentOptionIcon = styled.div`
  svg {
    width: 2.5rem;
    height: 2.5rem;
    display: block;
    fill: currentColor;
    ${TransitionPrimary('fill')}

    .primary {
      fill: var(--color-primary);
    }
  }
`

export const PaymentOptionContent = styled.div`
  flex: 1 1 auto;
  padding-right: 1.5rem;

  h2 {
    font-size: 1.3rem;
    margin-bottom: 0;
  }
`

export const PaymentOptionWrapper = styled.button`
  ${Reset('button')}
  width: 100%;
  position: relative;
  display: flex;
  height: 5rem;
  align-items: center;
  border-radius: 0.5rem;
  background-color: var(--color-body);
  padding: 0 2rem;
  text-align: left;
  transition: background-color 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;

  > * {
    position: relative;
  }

  &:before {
    ${Cover()}
    ${TransitionPrimary('transform, opacity, visibility')}
    border-radius: 0.5rem;
    visibility: hidden;
    opacity: 0;
    transform: scale(0.98);
    background-color: var(--color-global);
  }

  &:not(:last-child) {
    margin-bottom: 0.25rem;
  }

  &:hover {
    background-color: var(--color-light);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
    border-color: var(--color-primary);
  }

  ${props =>
    props.$active &&
    css`
      color: var(--color-inverted);
      background-color: var(--color-light);

      &:before {
        visibility: visible;
        opacity: 1;
        transform: scale(1);
      }
    `};
`

export const PaymentRadioButton = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid var(--color-primary);
  border-radius: 50%;
  margin-right: 1rem;
  flex-shrink: 0;
  position: relative;
  transition: background-color 0.3s ease, border-color 0.3s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1rem;
    height: 1rem;
    background-color: var(--color-primary);
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(${props => (props.$active ? 1 : 0)});
    transition: transform 0.3s ease;
  }
`



